import { render, staticRenderFns } from "./ClientsAccounts.vue?vue&type=template&id=333cbb42&"
import script from "./ClientsAccounts.vue?vue&type=script&lang=js&"
export * from "./ClientsAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports